exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".decoding-container .phase3 {\n  width: 100%;\n  height: 100%;\n  margin: 0; }\n\n.decoding-container .p3-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center; }\n\n.decoding-container .crayonClass {\n  width: 100%;\n  height: 100%; }\n", ""]);

